<script lang="ts">
  import { faHouse } from '@fortawesome/free-solid-svg-icons'
  import type { NavigationLink } from '../types'
  import { CATEGORIES } from '../categories'
  import { getI18n } from '../i18n'
  import NavigationDesktop from './NavigationDesktop.svelte'
  import NavigationMobile from './NavigationMobile.svelte'

  const i18n = getI18n()

  const links: NavigationLink[] = $derived.by(() => {
    const home = i18n.path('/welcome')
    const sightseeing = i18n.path('/pages/sightseeing')
    const events = i18n.path('/pages/events')
    const blog = i18n.path('/pages/blog')

    return [
      { label: i18n.t('navigation.home'), href: home, alias: `${home} ${home}#* ${home}?*`, icon: faHouse, variant: 'neutral' },
      { label: i18n.t('categories.sightseeing.name'), href: sightseeing, alias: `${sightseeing}*`, ...CATEGORIES.sightseeing },
      { label: i18n.t('categories.events.name'), href: events, alias: `${events}*`, ...CATEGORIES.events },
      { label: i18n.t('categories.blog.name'), href: blog, alias: `${blog}*`, ...CATEGORIES.blog },
    ]
  })
</script>

<NavigationDesktop {links} />
<NavigationMobile {links} />
